/* eslint-disable @typescript-eslint/no-explicit-any */
import type { MutableRefObject } from "react";

/**
 * Creates zoom control handlers for a map instance
 * @param mapRef - React ref containing the map instance
 * @returns Object with handleZoomIn and handleZoomOut functions
 */
export const createZoomHandlers = (mapRef: MutableRefObject<any>) => {
  const handleZoomIn = () => {
    if (mapRef.current) {
      mapRef.current.zoomIn();
    }
  };

  const handleZoomOut = () => {
    if (mapRef.current) {
      mapRef.current.zoomOut();
    }
  };

  return { handleZoomIn, handleZoomOut };
};
